import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Loader2, Sparkles, Eye } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function SimilarPracticesPanel({ projectId }) {
  const [loading, setLoading] = useState(false);
  const [matches, setMatches] = useState(null);
  const navigate = useNavigate();

  const find = async () => {
    setLoading(true);
    try { const { data } = await api.post(`/ai/similar-practices/${projectId}`); setMatches(data.matches || []); }
    catch { toast.error("Errore AI"); setMatches([]); }
    finally { setLoading(false); }
  };

  return (
    <Card className="p-5">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 font-heading font-semibold text-navy-900"><Sparkles className="w-4 h-4 text-amber-500" /> Precedenti analoghi</div>
        <Button size="sm" variant="outline" onClick={find} disabled={loading} data-testid="similar-btn">
          {loading ? <Loader2 className="w-3 h-3 animate-spin" /> : "Cerca con AI"}
        </Button>
      </div>
      {!matches && <div className="text-sm text-slate-400">L'AI cercherà pratiche analoghe gestite dallo Studio.</div>}
      {matches && matches.length === 0 && <div className="text-sm text-slate-400">Nessun precedente analogo trovato.</div>}
      {matches && matches.length > 0 && (
        <div className="space-y-2">
          {matches.map(m => (
            <div key={m.id} className="p-3 border border-slate-100 rounded-md hover:bg-slate-50">
              <div className="flex items-center gap-2 mb-1">
                <span className="font-mono text-xs text-slate-500">{m.numero_protocollo}</span>
                <span className="text-sm font-medium text-navy-900">{m.title}</span>
                <button onClick={()=>navigate(`/pratiche/${m.id}`)} className="ml-auto text-xs text-navy-600 hover:underline flex items-center gap-1"><Eye className="w-3 h-3" />Apri</button>
              </div>
              {m.reason && <div className="text-xs text-slate-600 italic">{m.reason}</div>}
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
